<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48" viewBox="0 0 48 48">
        <defs>
            <clipPath id="clip-Threema_Light">
                <rect width="48" height="48"/>
            </clipPath>
        </defs>
        <g id="Threema_Light" clip-path="url(#clip-Threema_Light)">
            <g id="Group_39129" data-name="Group 39129">
                <circle id="Ellipse_1069" class="svg-primary-color" data-name="Ellipse 1069" cx="24" cy="24" r="24" />
                <path id="Path_4419" class="svg-on-primary-color" data-name="Path 4419" d="M38,20c0-7.18-6.268-13-14-13S10,12.82,10,20a12.311,12.311,0,0,0,2.52,7.443L11.2,33l5.875-1.7A14.771,14.771,0,0,0,24,33C31.732,33,38,27.18,38,20ZM15,36a2,2,0,1,0,2,2A2,2,0,0,0,15,36Zm18,0a2,2,0,1,0,2,2A2,2,0,0,0,33,36Zm-9,0a2,2,0,1,0,2,2A2,2,0,0,0,24,36Z"/>
                <path id="Path_4420" class="svg-primary-color"  data-name="Path 4420" d="M29,19H28V17a4,4,0,0,0-8,0v2H19a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V20A1,1,0,0,0,29,19Zm-7.5-2a2.5,2.5,0,0,1,5,0v2h-5Z" fill="#263238"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "threemaIcon",
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/threemaIcon.vue